import axios from "axios";
import API from "../helpers/api";
import { toast, ToastContainer } from "react-toastify";

export const getMaterialDeclaration = (Id) => {
    let url = `${API.GetMaterialDeclaration}?MaterialDeclarationId=${Id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetMaterialDeclarationSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetMaterialDeclarationFailure",
                    error: "ERROR"
                })
            })
    }
}

export const putMaterialDeclaration = (data) => {
    let url = `${API.PutMaterialDeclaration}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "PutMaterialDeclarationSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PutMaterialDeclarationFailure",
                    error: "ERROR"
                })
            })
    }
}

export const deleteMaterialDeclaration = (Id) => {
    let url = `${API.DeleteMaterialDeclaration}?MaterialDeclarationId=${Id}`;
    return dispatch => {
        axios.delete(url)
            .then((response) => {
                dispatch({
                    type: "DeleteMaterialDeclarationSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "DeleteMaterialDeclarationFailure",
                    error: "ERROR"
                })
            })
    }
}